<template>
  <div class="home">
    <HallBuilder />
  </div>
</template>

<script>
// @ is an alias to /src
import HallBuilder from '@/components/HallBuilder.vue'

export default {
  name: 'home',
  components: {
    HallBuilder
  }
}
</script>
